<template>
   <div class="profile-nav">
      <Tabs noBorder>
         <li v-for="link in links" class="tab" :key="link.label">
            <nuxt-link class="tab-link" :to="link.to">
               {{ link.label }}
            </nuxt-link>
         </li>
      </Tabs>

      <FormGenerator
         v-if="schema && profileFilter.options"
         id="profile-filter"
         onUpdate
         :schema="schema"
         @updated="handleFilter"
         :init-value="{ filter: `${profileFilter.options[0].value}` }"
         :key="profileFilter.options"
         class="simple"
      />
      <div class="actions">
         <slot name="actions"></slot>
      </div>
   </div>
</template>

<script setup lang="ts">
const { profileFilter } = useProfile();
const route = useRoute();

const buildFilter = () => {
   const matchLink = links.value.find((link) => link.to.name === route.name);
   if (matchLink) {
      profileFilter.value.options = matchLink.filters;
      profileFilter.value.active = matchLink?.filters[0]?.value
         ? matchLink.filters[0].value
         : null;
   }
};

const handleFilter = (ctx: { filter?: string } | undefined) => {
   profileFilter.value.active = ctx?.filter ?? null;
};

const links = computed(() => {
   return [
      {
         label: "Classes",
         to: { name: "profile-classes", path: "/profile/classes" },
         filters: [
            { text: "Active", value: "active", tag: "option" },
            { text: "Archived", value: "archived", tag: "option" },
         ],
      },
      {
         label: "Lesson Plans",
         to: { name: "profile-lesson-plans", path: "/profile/lesson-plans" },
         filters: [
            { text: "Most Recent", value: "recent", tag: "option" },
            { text: "Alphabetical", value: "alpha", tag: "option" },
         ],
      },
      {
         label: "Core Works",
         to: { name: "profile-core-works", path: "/profile/core-works" },
         filters: [
            { text: "Most Recent", value: "recent", tag: "option" },
            { text: "Alphabetical", value: "alpha", tag: "option" },
         ],
      },
      {
         label: "Units & Sequences",
         to: {
            name: "profile-units",
            path: "/profile/units-and-sequences",
         },
         filters: [
            { text: "Most Recent", value: "recent", tag: "option" },
            { text: "Alphabetical", value: "alpha", tag: "option" },
         ],
      },
      {
         label: "PD",
         to: {
            name: "profile-pd",
            path: "/profile/pd",
         },
         filters: [],
      },
      {
         label: "Media",
         to: {
            name: "profile-media",
            path: "/profile/media",
         },
         filters: [],
      },
      {
         label: "Pilot Resources",
         to: {
            name: "profile-pdfs",
            path: "/profile/pdfs",
         },
         filters: [],
      },
   ];
});

const schema = computed(() => {
   if (profileFilter.value.active) {
      return {
         fields: [
            {
               name: "filter",
               as: "basic-select",
               inputStyle: "simple",
               children: profileFilter.value.options,
            },
         ],
      };
   }
   return null;
});

onBeforeMount(() => {
   buildFilter();
});
watch(
   () => route.name,
   () => {
      buildFilter();
   },
);
</script>

<style lang="scss">
@import "~/assets/scss/profile/profile-nav";
</style>
